import React from "react";

export default function BagLoader() {
  return (
    <svg
      viewBox="0 0 900 1000"
      width="200"
      height="300"
      xmlns="http://www.w3.org/2000/svg"
    >
      <style>
        {`
        .bag { fill:white; stroke:#333; stroke-width:8; }
        .handle { fill:none; stroke:#333; stroke-width:20; stroke-linecap:round; }
        .eye { fill:#333; }
        .mouth { stroke:#333; stroke-width:6; fill:none; stroke-linecap:round; }
        .limb { fill:none; stroke:#333; stroke-width:22; stroke-linecap:round; }
        .glove { fill:white; stroke:#333; stroke-width:5; }
        .shoe { fill:#333; stroke:#000; stroke-width:2; }

        @keyframes bodyBob {0%,100%{transform:translateY(0);}50%{transform:translateY(-15px);}}
        @keyframes legL {0%,100%{transform:rotate(15deg);}50%{transform:rotate(-15deg);}}
        @keyframes legR {0%,100%{transform:rotate(-15deg);}50%{transform:rotate(15deg);}}
        @keyframes armL {0%,100%{transform:rotate(-10deg);}50%{transform:rotate(25deg);}}
        @keyframes armR {0%,100%{transform:rotate(10deg);}50%{transform:rotate(-25deg);}}
        @keyframes blink {0%,45%,55%,100%{transform:scaleY(1);}50%{transform:scaleY(0.2);}}
        @keyframes smile {0%,100% { d:path("M370 530 Q450 590 530 530"); }50% { d:path("M370 520 Q450 600 530 520"); }}

        #body { animation:bodyBob 1s ease-in-out infinite; transform-origin:50% 100%; }
        #legL { animation:legL 1s ease-in-out infinite; transform-origin:350px 760px; }
        #legR { animation:legR 1s ease-in-out infinite; transform-origin:550px 760px; }
        #armL { animation:armL 1s ease-in-out infinite; transform-origin:200px 360px; }
        #armR { animation:armR 1s ease-in-out infinite; transform-origin:700px 360px; }
        #eyeL,#eyeR { animation:blink 3s infinite; transform-origin:center; }
        #mouth { animation:smile 2s ease-in-out infinite; }
      `}
      </style>

      <g id="body">
        <path className="bag" d="M200 220 L700 220 L740 760 Q740 820 700 840 L200 840 Q160 820 160 760 Z"/>
        <path className="handle" d="M300 220 Q450 80 600 220"/>
        <circle id="eyeL" className="eye" cx="370" cy="420" r="28"/>
        <circle id="eyeR" className="eye" cx="530" cy="420" r="28"/>
        <path id="mouth" className="mouth" d="M370 530 Q450 590 530 530"/>
      </g>

      <g id="armL">
        <path className="limb" d="M200 360 Q120 420 140 520"/>
        <circle className="glove" cx="140" cy="520" r="34"/>
      </g>
      <g id="armR">
        <path className="limb" d="M700 360 Q780 420 760 520"/>
        <circle className="glove" cx="760" cy="520" r="34"/>
      </g>

      <g id="legL">
        <path className="limb" d="M360 760 Q340 860 350 930"/>
        <ellipse className="shoe" cx="350" cy="950" rx="48" ry="22"/>
      </g>
      <g id="legR">
        <path className="limb" d="M560 760 Q580 860 570 930"/>
        <ellipse className="shoe" cx="570" cy="950" rx="48" ry="22"/>
      </g>
    </svg>
  );
}
